import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { WidgetDocumentation, WidgetUsefulTip } from 'src/app/models/widget';
import { HttpContextConfig } from 'src/app/models/http-context-config';
import { CONFIG } from 'src/app/interceptors/loader.interceptor';

const baseUrl: string = `${environment.api}/widgets/`;
const minitoringUrl: string = `${environment.api}/monitoring`;
const monitoringReviewUrl: string = `${environment.api}/monitoringreview`;
const deltaMonitoringReviewUrl: string = `${environment.api}/deltamonitoring`;

const config = new HttpContextConfig();
config.noSpinner = true;

@Injectable({
  providedIn: 'root'
})
export class WidgetService {
  private readonly http: HttpClient = inject(HttpClient);

  getSoftSkills(
    chosenUser?: string,
    selectedReviewId?: number | string
  ): Observable<any> {
    let params = new HttpParams();

    if (chosenUser) {
      params = params.set('chosen_user', chosenUser);
    }

    if (selectedReviewId !== undefined) {
      params = params.set('review_id', selectedReviewId.toString());
    }

    return of({ result: [] });
  }

  getProfileCardData(
    id: number | string,
    chosenUser?: string
  ): Observable<any> {
    let params = new HttpParams();

    if (chosenUser) {
      params = params.set('chosen_user', chosenUser);
    }

    // Aggiungi l'ID come parametro (convertito in stringa se necessario)
    params = params.set('id', id.toString());

    return of({ result: null });
  }

  getTechnicalSkills(
    chosenUser?: string,
    selectedReviewId?: number | string // Nuovo parametro opzionale
  ): Observable<any> {
    let params = new HttpParams();

    if (chosenUser) {
      params = params.set('chosen_user', chosenUser);
    }

    if (selectedReviewId !== undefined) {
      params = params.set('review_id', selectedReviewId.toString());
    }

    return of({ result: [] });
  }

  getUserDocumentation(
    chosenUser?: string,
    selectedReviewId?: number | string
  ): Observable<WidgetDocumentation> {
    let params = new HttpParams();

    if (chosenUser) {
      params = params.set('chosen_user', chosenUser);
    }

    if (selectedReviewId !== undefined) {
      params = params.set('review_id', selectedReviewId.toString());
    }

    return of({ result: [] } as unknown as WidgetDocumentation);
  }

  getUserUsefulTips(
    chosenUser?: string,
    selectedReviewId?: number | string
  ): Observable<WidgetUsefulTip> {
    let params = new HttpParams();

    if (chosenUser) {
      params = params.set('chosen_user', chosenUser);
    }

    if (selectedReviewId !== undefined) {
      params = params.set('review_id', selectedReviewId.toString());
    }

    return of({ result: [] } as unknown as WidgetUsefulTip);
  }

  getUserCompletedHelpRequests(
    chosenUser?: string,
    selectedReviewId?: number | string
  ): Observable<any> {
    let params = new HttpParams();

    if (chosenUser) {
      params = params.set('chosen_user', chosenUser);
    }

    if (selectedReviewId !== undefined) {
      params = params.set('review_id', selectedReviewId.toString());
    }

    return of({ result: [] });
  }

  getUserFeedbacksByUserId(
    chosenUser?: string,
    selectedReviewId?: number | string
  ): Observable<any> {
    let params = new HttpParams();

    if (chosenUser) {
      params = params.set('chosen_user', chosenUser);
    }

    if (selectedReviewId !== undefined) {
      params = params.set('review_id', selectedReviewId.toString());
    }

    return of({ result: [] });
  }

  getShareWidget(
    chosenUser?: string,
    selectedReviewId?: number | string
  ): Observable<any> {
    let params = new HttpParams();

    if (chosenUser) {
      params = params.set('chosen_user', chosenUser);
    }

    if (selectedReviewId !== undefined) {
      params = params.set('review_id', selectedReviewId.toString());
    }

    return of({ result: [] });
  }

  getImprovement(
    chosenUser?: string,
    selectedReviewId?: number | string
  ): Observable<any> {
    let params = new HttpParams();

    if (chosenUser) {
      params = params.set('chosen_user', chosenUser);
    }

    if (selectedReviewId !== undefined) {
      params = params.set('review_id', selectedReviewId.toString());
    }

    return of({ result: [] });
  }

  getMonitoring(data: any) {
    let params;
    if (data.chosenUser)
      params = {
        user_id: data.chosenUser,
        selectedReviewId: data.selectedReviewId,
        start_date: data.start_date,
        end_date: data.end_date
      };
    else
      params = {
        selectedReviewId: data.selectedReviewId,
        start_date: data.start_date,
        end_date: data.end_date
      };
    return of({ result: [] });
  }

  getMonitoringReview(data: any): Observable<any> {
    return of({ result: [] });
  }

  getMonitoringVelocityReview(data: any): Observable<any> {
    return of({ result: [] });
  }

  storeMonitoringVelocityReviewComment(data: any): Observable<any> {
    return of({ result: data });
  }
}
